import styled from 'styled-components';
import Header from './component';

export default styled(Header)`
  height: 48px;
  width: 100%;
  background-color: var(--grey100);
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0 16px;

  .driver {
    text-transform: uppercase;
    font-weight: bolder;
    color: var(--grey900);
  }

  .driver__name--active {
    color: var(--primary500);
    text-decoration: none;

    &:hover {
      text-decoration: underline;
    }
  }

  .driver__name--inactive {
    color: var(--grey500);
  }
`;
